import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import useSeo, { ensureJsonLd } from '@/hooks/useSeo';
import { characters } from '@/mocks/manga';

export default function Characters() {
  useSeo({
    title: '泡在我家的辣妹人物角色设定介绍 泡在我家的辣妹漫画介绍',
    description:
      '泡在我家的辣妹人物角色设定介绍：女主藤野澪、男主森下直人，还有闺蜜、学姐、妹妹与青梅竹马。帮你理清泡在我家的辣妹漫画介绍中的角色关系与性格特点。',
    keywords: '泡在我家的辣妹人物,泡在我家的辣妹角色设定,泡在我家的辣妹角色,泡在我家的辣妹漫画介绍',
    path: '/characters',
  });

  useEffect(() => {
    ensureJsonLd('ld-breadcrumb', {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://dramaquest2.github.io/' },
        { '@type': 'ListItem', position: 2, name: '人物角色', item: 'https://dramaquest2.github.io/characters' },
      ],
    });
    ensureJsonLd('ld-characters', {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: '泡在我家的辣妹主要角色',
      itemListElement: characters.map((c, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        name: c.name,
        description: c.intro,
      })),
    });
    return () => {
      ['ld-breadcrumb', 'ld-characters'].forEach((id) => document.getElementById(id)?.remove());
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <header className="bg-background-100">
          <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16 lg:px-8">
            <nav aria-label="面包屑" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
              <Link to="/" className="hover:text-primary-600">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-700">人物角色</span>
            </nav>
            <span className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-group-line"></i>
              人物角色
            </span>
            <h1 className="mt-4 text-2xl leading-snug text-foreground-950 md:text-4xl">
              在同一屋檐下相遇的他们
            </h1>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              一部作品的灵魂在于角色。《泡在我家的辣妹》里，每个登场人物都有着自己的性格与故事，正是这些鲜活的角色碰撞出了这段温暖的同居日常。这里为你整理主要角色的设定与特点。
            </p>
          </div>
        </header>

        <section className="bg-background-50 py-12 md:py-16">
          <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
              {characters.map((c) => (
                <article key={c.id} className="flex flex-col overflow-hidden rounded-lg bg-background-100">
                  <img
                    src={c.image}
                    alt={`泡在我家的辣妹角色${c.name}插画`}
                    className="h-72 w-full object-cover object-top"
                  />
                  <div className="flex flex-1 flex-col p-5">
                    <div className="flex items-center justify-between gap-2">
                      <h2 className="font-heading text-xl text-foreground-950">{c.name}</h2>
                      <span className="text-xs font-medium text-secondary-700">{c.role}</span>
                    </div>
                    <div className="mt-2 flex flex-wrap gap-2">
                      {c.tags.map((t) => (
                        <span key={t} className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-800">
                          {t}
                        </span>
                      ))}
                    </div>
                    <p className="mt-3 text-sm font-medium text-foreground-800">{c.intro}</p>
                    <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{c.detail}</p>
                  </div>
                </article>
              ))}
            </div>

            <aside className="mt-12 rounded-lg bg-primary-900 p-6 md:p-8">
              <h3 className="font-heading text-xl text-background-50">想从剧情角度看这些角色？</h3>
              <p className="mt-2 text-sm text-background-200">
                角色是故事的载体，了解了他们的性格，再看剧情主线时会更有代入感。
              </p>
              <Link
                to="/plot"
                className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-400"
              >
                回到剧情主线
                <i className="ri-arrow-right-line"></i>
              </Link>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}